import { ref, get } from 'firebase/database';
import { database } from '../../Firebase/firebaseconfig';

// Generates a random 6-digit number that does NOT already exist under the given
// Realtime-DB node ('bill' or 'quote'), so invoice/quote numbers are always
// unique. Retries on collision; a timestamp-based fallback guarantees it always
// returns even in the (practically impossible) event of saturation.
export async function generateUniqueNumber(node) {
  for (let attempt = 0; attempt < 40; attempt++) {
    const candidate = String(Math.floor(100000 + Math.random() * 900000));
    // eslint-disable-next-line no-await-in-loop
    const snap = await get(ref(database, `${node}/${candidate}`));
    if (!snap.exists()) return candidate;
  }
  return String(Date.now()).slice(-6);
}
